




































































































































































































































































































import Vue from 'vue';
import Tabs from "@/components/Tabs.vue";
import store, { CashPreAccEditorStore } from "../services/CashPreAccEditorStore";
import { CashPreAccEditDimension, CashPreAccEditDimensionDefaultProps, CashPreAccEditItem } from '../models/CashPreAccEditing';
import CashBasicGridDimensionWrapper from './CashBasicGridDimensionWrapper.vue';
import LookupComboBox from "@/components/LookupComboBox.vue";
import { t } from "@/plugins/i18n";

const ROMAN = ["IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];

const baseColumns = [
  {
    field: "id",
    title: " ",
    cell: 'command',
    width: "100px"
  },
  {
    field: "dimCode",
    title: t("DimenzioKod"),
    cell: "dimCodeName",
  },
  {
    field: "total",
    title: t("Osszeg"),
    cell: "totalTemplate",
  },
];
const endColumns = [
  {
    width: "0px",
    filterable: false,
  },
];

interface Data {
  store: CashPreAccEditorStore;
}

interface Methods {
  preSetItems(e: any): void;
  onRowClick(item: any): void;
  confirmDelete(item: CashPreAccEditDimension): void;
  setDimCodeType(num: number): void;
  setDefaultSelectedValues(num: number): void;
  tabEnabled(type: number): boolean;
  onSelectedProjectUpdate(value: any, item: CashPreAccEditDimension): void;
  onSelectedPoUpdate(value: any, item: CashPreAccEditDimension): void;
  onValueChanged(item: CashPreAccEditDimension): void;
  onCarValueChanged(item: CashPreAccEditDimension, newValue: any): void;
  onStationValueChanged(item: CashPreAccEditDimension, newVal: any): void;
  onUserValueChanged(item: CashPreAccEditDimension, newVal: any): void;
  onToolValueChanged(item: CashPreAccEditDimension, newVal: any): void;
  productions(projectID: number): object[];
  checkChange(item: any, codeField: string, idField: string, nameField: string): void;
  handleChange(item: CashPreAccEditDimension, codeField: string, idField: string, nameField: string): void;
}
interface Computed {
  dimTabs: { type: number; label: string }[];
  dim4columns: any;
  dim5columns: any;
  dim6columns: any;
  dim7columns: any;
  dim8columns: any;
  dim9columns: any;
  dim10columns: any;
  dim11columns: any;
  dim12columns: any;
  positiveNegativeItem: CashPreAccEditItem;
  positiveNegativeDimensionCodeType: number;
  positiveNegativeDimension: CashPreAccEditDimension;
  activeDimensions: CashPreAccEditDimension[];
}

interface Props {
  positiveNegative: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    positiveNegative: {type: String},
  },

  components: {
    Tabs,
    CashBasicGridDimensionWrapper,
    LookupComboBox,
  },

  data() {
    return {
      store,
    }
  },

  methods: {
    preSetItems(e: any) {
      const type = e.currentTarget.dataset.type;
      this.setDimCodeType(Number(type));
    },
    onRowClick(item){
      store.selectedDimension = item.dataItem;
      this.positiveNegativeDimension = item.dataItem
    },
    confirmDelete(item){
      this.$emit('deleteDimItem',item);
    },
    setDimCodeType(num){
      this.positiveNegativeDimensionCodeType = num;
    },
    setDefaultSelectedValues(num){
      const array = this.store.dimensionsRows.filter(x => x.head == this.positiveNegativeItem.id && x.dimCodeType == num);
      if(array.length > 0){
        this.positiveNegativeDimension = array[0];
      }
      else{
        this.positiveNegativeDimension = {...CashPreAccEditDimensionDefaultProps};
      }
    },
    // K2D tab-tiltás (w_popup_accitem_dim_os): külső főkönyvnél a csaccdimcodetype
    // élőség típusonként; egyébként minden fül engedélyezett
    tabEnabled(type){
      if(this.store.flags.extBook){
        return this.store.flags.dimTypeLive[type] !== false;
      }
      return true;
    },
    // Guard mindhárom LookupComboBox-os kezelőn: Enter-re csonk objektum is
    // érkezhet (ismert, halasztott hiba) — undefined azonosítót nem írunk be
    onSelectedProjectUpdate(val,item){
      if (!val || val.id === undefined) return;
      item.project = val.id;
      item.projectMainCode = val.mainCode;
      item.projectName = val.name;
      item.projectCode = val.code;
      item.poId = 1;
      item.poNumber = "-";
      item.workNumber = "-";
    },
    onSelectedPoUpdate(val,item){
      if (!val || val.id === undefined) return;
      item.poId = val.id;
      item.poNumber = val.poNumber;
      item.workNumber = val.workNumber;
    },
    productions(projectID){
      if(projectID === 1)
        return this.store.pos;

      return this.store.pos.filter((i: any) => i.project == projectID)
    },
    onValueChanged(item){
      this.store.syncDimensionModified(item);
    },
    onCarValueChanged(item, newVal){
      if (!newVal || newVal.id === undefined) return;
      item.carId = newVal.id,
      item.regNum = newVal.reqNum
    },
    onStationValueChanged(item, newVal){
      item.stationName = newVal.name
      item.stationId = newVal.id

      item.userName = item.toolName = "-"
      item.userId = item.toolId = 1
    },
    onUserValueChanged(item,newVal){
      item.userName = newVal.name
      item.userId = newVal.id

      item.stationName = item.toolName = "-"
      item.stationId = item.toolId = 1
    },
    onToolValueChanged(item,newVal){
      item.toolName = newVal.name
      item.toolId = newVal.id

      item.stationName = item.userName = "-"
      item.stationId = item.userId = 1
    },
    async checkChange(item, codeField, idField, nameField) {
      if (!item[codeField]) {
        item[idField] = 1;
        nameField != "" ? item[nameField] = "-" : nameField;
        return;
      }
      let isValid: any;
      if(nameField != ""){
        isValid = await this.store.isValidPartCode(item[codeField]);
      }
      else{
        isValid =  await this.store.ValidPartnerName(item[codeField])
      }

      if (isValid.id > 1) {
        item[idField] = isValid.id;
        nameField != "" ? item[nameField] = isValid.name : nameField;
      } else {
        item[idField] = 1;
        nameField != "" ? item[nameField] = "-" : nameField;
      }
    },
    async handleChange(item, codeField, idField, nameField){
      try {
        await this.checkChange(item, codeField,idField,nameField);
        this.onValueChanged(item);
      } catch (err) {
        console.error(err);
      }
    },
  },

  computed: {
    dimTabs() {
      // K2D-paritás: csaccdimcodetype 5 = IV. dim ... 13 = XII. dim
      return ROMAN.map((label, i) => ({ type: i + 5, label: t("GeneralLedger_Dimenzio", [label]) }));
    },
    dim4columns: () =>[
      ...baseColumns,
      ...endColumns
    ],
    // Fülenkénti kísérő oszlopok a K2D láthatóság-térképe szerint (a bank és a
    // pénztár bontása azonos oszlopkészletű — közös n_cst_accitem_dim_os)
    dim5columns: () =>[
      ...baseColumns,
      {
        field: "extProdParts",
        title: t("SelejtCikk")
      },
      {
        field: "extProdPartsCode",
        title: t("Cikkszam"),
        cell: "partsCode"
      },
      {
        field: "extProdPartsName",
        title: t("Megnevezes"),
      },
      ...endColumns
    ],
    dim6columns: () => [
      ...baseColumns,
      {
        field: "productParts",
        title: t("GyartottTermek")
      },
      {
        field: "productPartsCode",
        title: t("Cikkszam"),
        cell: "partsCode"
      },
      {
        field: "productPartsName",
        title: t("Megnevezes")
      },
      {
        field: "production",
        title: t("GyartasInformacio")
      },
      {
        field: "stock",
        title: t("Keszlet")
      },
      ...endColumns
    ],
    dim7columns: () => [
      ...baseColumns,
      {
        field: "carId",
        title: t("Gepjarmu"),
        cell: "car"
      },
      {
        field: "regNum",
        title: t("Rendszam"),
        cell: "regNum"
      },
      ...endColumns
    ],
    dim8columns: () => [
      ...baseColumns,
      {
        field: "userName",
        title: t("Munkatars"),
        cell: "userName"
      },
      {
        field: "stationName",
        title: t("Munkaallomas"),
        cell: "stationName"
      },
      {
        field: "toolName",
        title: t("Szerszam"),
        cell: "toolName"
      },
      ...endColumns
    ],
    dim9columns: () => [
      ...baseColumns,
      {
        field: "project",
        title: t("Projekt"),
        cell: "projectID"
      },
      {
        field: "projectName",
        title: t("ProjektNeve")
      },
      {
        field: "poId",
        title: t("Megrendeles"),
        cell: "poId"
      },
      {
        field: "poNumber",
        title: t("MegrendelesSzam")
      },
      {
        field: "workNumber",
        title: t("Munkaszam")
      },
      ...endColumns
    ],
    dim10columns: () => [
      ...baseColumns,
      {
        field: "extProdPartner",
        title: t("KiegeszitoPartner")
      },
      {
        field: "extProdPartnerName",
        title: t("PartnerNeve"),
        cell: "extProdPartnerName"
      },
      ...endColumns
    ],
    dim11columns: () => [
      ...baseColumns,
      ...endColumns
    ],
    dim12columns: () => [
      ...baseColumns,
      ...endColumns
    ],
    positiveNegativeItem(){
      return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedItem : this.store.negativeSelectedItem;
    },
    positiveNegativeDimension:{
      get() {
        return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedDimension : this.store.negativeSelectedDimension;
      },
      set(newVal) {
        if (this.$props.positiveNegative === "positive") {
          this.store.positiveSelectedDimension = newVal;
        } else {
          this.store.negativeSelectedDimension = newVal;
        }
      }
    },
    positiveNegativeDimensionCodeType: {
      get() {
        return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedDimCodeType : this.store.negativeSelectedDimCodeType;
      },
      set(newVal) {
        if (this.$props.positiveNegative === "positive") {
          this.store.positiveSelectedDimCodeType = newVal;
        } else {
          this.store.negativeSelectedDimCodeType = newVal;
        }
      }
    },
    activeDimensions(){
      // A kontírtétel mindig létező (pozitív id-jú) sor — a bontás a head-en kötődik
      return store.dimensionsRows.filter((x) =>
        x.dimCodeType == this.positiveNegativeDimensionCodeType &&
        x.head == this.positiveNegativeItem.id
      )
      .map(item =>
        {
          item.selected = item === this.store.selectedDimension;
          item.inEdit = item === this.store.selectedDimension;
          return item;
        }
      );
    }
  },
  watch:{
    activeDimensions:{
      handler(newVal,oldVal) {
        if(newVal[0] != oldVal[0]){
          this.setDefaultSelectedValues(this.positiveNegativeDimensionCodeType);
        }
      },deep: true
    },
    positiveNegativeItem(){
      // K2D retrieveend: a legkisebb LÉTEZŐ dimcodetype lesz az aktív fül;
      // ha a tételnek nincs bontása, az első engedélyezett fülre ugrunk.
      const item = this.positiveNegativeItem;
      const existing = this.store.dimensionsRows
        .filter(x => x.head == item.id)
        .map(x => x.dimCodeType)
        .sort((a, b) => a - b);
      let type = existing.length > 0 ? existing[0] : 0;
      if (type < 5 || type > 13) {
        const firstEnabled = this.dimTabs.find(t => this.tabEnabled(t.type));
        type = firstEnabled ? firstEnabled.type : 5;
      }
      this.setDimCodeType(type);
      (this.$refs.tab as any).setTab(type - 5);
    }
  }
})
